export abstract class OctoLink {
    public static BaseAddress: string = "https://oc.to/";
    public static Create(path: string): string {
        return OctoLink.BaseAddress + path;
    }
}
